module.exports = __webpack_public_path__ + "static/media/220RO.292df036.jpg";